import { useLocation } from 'react-router-dom';

const useCheckFavoriteRoute = () => {
  const { pathname } = useLocation();

  return pathname.indexOf('/favorite') > -1;
};

export default useCheckFavoriteRoute;
